// extracted by mini-css-extract-plugin
module.exports = {"headerBar":"ui-z","pointsSection":"vi-z","goToDashboard":"wi-z"};